<template>
  <el-row style="height: 100%;width: 100%;display: flex;background-color: rgba(255, 255, 255, 0.8);">
    <el-aside class="common-panel-aside" width="251px" style="border-right: 1px solid #FFF;overflow: hidden;">
      <!-- 树标题区域 -->
      <!-- 树上方工具区域 搜索栏为默认存在 若包含工具按钮需设置hasTreeToolbar为true-->
      <el-row class="doc-tree-top">
        <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
      </el-row>
      <!-- 树区域 -->
      <el-tree
        :data="treeData" :filter-node-method="filterNode" :props="treeProps" node-key="id" ref="tree" @node-click="handleNodeClick"
        :default-expanded-keys="expandKeys" highlight-current class="aside-tree">
          <span slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            {{ node.label }}
          </span>
      </el-tree>
    </el-aside>
    <el-main>
      <div class="device-info">
        <div class="device-pic"></div>
        <div class="device-detail">
          <div class="device-detail-text">型号：{{deviceInfo.devModel}}</div>
          <div class="device-detail-text">安装位置：{{deviceInfo.installAddr}}</div>
          <div class="device-detail-text">状态：{{deviceInfo.status}}</div>
        </div>
      </div>
      <div class="filter-radio-area">
        <el-radio-group v-model="selRadio" class="filter-radio" @change="doQuery(false)" size="medium">
          <el-radio-button v-for="radio in radioList" :label="radio.id" :key="radio.id">{{radio.name}}</el-radio-button>
        </el-radio-group>
      </div>
      <div style="height: calc(100% - 240px);" class="table">
        <el-table :data="tableData" height="calc(100% - 40px)" ref="tableList"
                  class="common-panel-table" border fit>
          <el-table-column type="index" label="序号" width="60"/>
          <el-table-column v-for="(item,i) in tableProps" :key="i"
                    :prop="item.prop" :label="item.label" :width="item.width">
            <template slot-scope="scope">
              <span>{{scope.row[item.prop]}}</span>
            </template>
          </el-table-column>
          <el-table-column :width="handleButtons.length * 56" label="操作">
            <template slot-scope="scope">
              <el-tooltip v-for="handleType in handleButtons" v-if="handleType" :key="handleType.label" :content="handleType.label" class="item" effect="dark" placement="top-start">
                <div class="table-button">
                  <el-button type="text" style="font-size: 20px;color: #3079D8;" @click="btnClick(handleType.type, scope.row)" :icon="handleType.icon" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style='height:40px;margin-left: 10px;margin-top: 4px;' @current-change="handlePageChange" @size-change="handleSizeChange"
                       :current-page='currPageNo' :page-size="pageSize" :total="total"
                       layout="total, sizes, prev, pager, next, jumper" :page-sizes="[18,36,54,72,90]"
                       background/>
      </div>
    </el-main>
    <el-dialog class="curve-dialog-class" :append-to-body="true" :close-on-click-modal="false" width="800px" center
               title="历史曲线" :visible.sync="curveDialogVisible">
      <curve-dialog v-if="curveDialogVisible" :sensorId="sensorId" :dataId="dataId" />
    </el-dialog>
  </el-row>
</template>

<script>
import CurveDialog from './CurveDialog.vue'
export default {
  name: "ProtectDevice",
  components: {
    CurveDialog
  },
  data() {
    return {
      mediaId: '40',
      filterName: '',
      treeProps: {
        children: 'childNode',
        label: 'name'
      },
      selNode: '',
      expandKeys: [],
      treeData: [],
      deviceInfo: {
        devModel: '',
        installAddr: '',
        status: ''
      },
      selRadio: 0,
      radioList: [{id: 0, name: '遥信'}, {id: 1, name: '遥测'}, {id: 4, name: 'SOE'}],
      tableData: [],
      currPageNo: 1,
      pageSize: this.GlobalConfig.PAGE_SIZE_18,
      total: 0,
      tableProps: [{prop: 'dataName', label: '名称', width: '300'}, {prop: 'dataValue', label: '值', width: '300'}, {prop: 'dataTime', label: '更新时间'}],
      handleButtons: [{type: 'curve', label: '历史曲线', icon: 'zy-icon-fuheshuai'}],
      sensorId: '',
      dataId: '',
      curveDialogVisible: false
    }
  },
  created() {
    this.getTree()
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(cNode, node) {
      this.selNode = cNode;
      this.doQuery(true);
    },
    getTree() {
      this.$api.systemManage.getSensorTree(this.mediaId).then(res => {
        this.treeData = res.data;
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childList && pNode.childList.length > 0) {
        leafNode = this.getLeafNode(pNode.childList[0]);
      }else if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }else if (pNode.children && pNode.children.length > 0) {
        leafNode = this.getLeafNode(pNode.children[0]);
      }
      return leafNode;
    },
    // 设置选中的树节点
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    doQuery(flag) {
      if (flag) {
        this.queryDevice()
      }
      this.$api.extraDevice.getRealtimeData({page: this.currPageNo, rows: this.pageSize, id: this.selNode.id, dataType: this.selRadio}).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.total
      })
    },
    queryDevice() {
      this.$api.extraDevice.getDeviceDetail({id: this.selNode.id}).then(res => {
        this.deviceInfo = res.data
      })
    },
    btnClick(type, item) {
      this.sensorId = item.sensorId
      this.dataId = item.dataId
      if (type === 'curve') {
        this.curveDialogVisible = true
      }
    },
    handlePageChange(pageNo) {
      this.currPageNo = pageNo;
      this.doQuery();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.doQuery();
    }
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  }
}
</script>

<style scoped>
  .common-panel-aside{
    height: 100%;
  }
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .el-main{
    width: calc(100% - 250px);
    height: 100%;
    overflow-y: hidden;
  }
  .device-info {
    height: 150px;
    padding: 20px 30px 20px 30px;
    width: calc(100% - 60px);
    display: flex;
  }
  .device-pic {
    background: url('../../../assets/images/protect.png') no-repeat;
    background-size: 100% 100%;
    width: 180px;
    height: 100%;
  }
  .device-detail {
    height: 100%;
    margin-left: 20px;
    width: calc(100% - 200px);
    text-align: left;
    font-size: 14px;
  }
  .device-detail-text {
    height: 50px;
    line-height: 50px;
  }
  .filter-radio-area {
    width: calc(100% - 1px);
    padding: 10px 0 0 1px;
    height: 40px;
    display: flex;
  }
  .filter-radio {
  }
  .table {
    text-align: left;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  /*.table /deep/ .el-table th {*/
  /*  background-color: rgba(2, 124, 247, 0.2);*/
  /*  border-top: 0;*/
  /*}*/
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
  .item {
    display: inline-flex;
    width: 30px;
    margin-left: 10px;
  }
  .table-button {
  }
  .table-button .el-button--text {
    color: #4444c7;
    background: 0 0;
    padding-left: 0;
    padding-right: 0;
  }
  .table-button .el-button--text:hover {
    color: #a8a8a8;
    border-color: transparent;
    background-color: transparent;
  }
  .table-button .el-button--text:focus {
    color: #a8a8a8;
    border-color: transparent;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/ExtraDevice/ProtectDevice.vue